import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import OrderTagManagement from 'components/Admin/OrderTagManagement';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <OrderTagManagement />
      </SiteContent>
    </ContentLayout>
  );
};
